import React, { useRef, useEffect } from 'react'
import * as S from './styles'
const BaseModal = ({ visibility = false, setVisibility = undefined, icon, title, subTitle, children }) => {
  const myElementRef = useRef(null)
  const handleClickOutside = (event) => {
    if (myElementRef.current && !myElementRef.current.contains(event.target)) {
      setVisibility(false)
    }
  }
  useEffect(() => {
    if (visibility) {
      // Adiciona um ouvinte de evento de clique global
      document.addEventListener('click', handleClickOutside)
      return () => {
        // Remove o ouvinte de evento de clique quando o componente é desmontado
        document.removeEventListener('click', handleClickOutside)
      }
    }
  }, [visibility])
  return (
    <>
      <S.ModalWrapper isVisible={visibility}>
        <S.ModalContent ref={myElementRef}>
          <S.ModalHeader>
            <S.Icon>
              {icon}
            </S.Icon>
            <S.Title>{title}</S.Title>
            <S.SubTitle>{subTitle}</S.SubTitle>
          </S.ModalHeader>
          {children}
        </S.ModalContent>
      </S.ModalWrapper>
    </>
  )
}
export default BaseModal
